import { $can } from '@pendo/permissions';
import { STATUS_TYPES } from '@/orchestrate/journeys/status.constants';
const { ACTIVE } = STATUS_TYPES;

function checkPermission (appId, action, entity = 'journey', source = 'ANY', target = 'ANY') {
    if (!appId || !action) {
        return false;
    }

    return $can(appId)
        .entity(entity)
        .action(action)
        .source(source)
        .target(target);
}

export function canCreateJourney ({ appId, source, target }) {
    return checkPermission(appId, 'create', 'journey', source, target)
        || checkPermission(appId, 'create', 'guide', source, target);
}

export function canUpdateJourney ({ appId, source, target, journey }) {
    const derivedSource = deriveSourceFromStatus(source, journey?.status);

    return checkPermission(appId, 'edit', 'journey', derivedSource.journey, target)
        || checkPermission(appId, 'edit', 'guide', derivedSource.guide, target);
}

export function canDeleteJourney ({ appId, source, target, journey }) {
    const derivedSource = deriveSourceFromStatus(source, journey?.status);

    return checkPermission(appId, 'remove', 'journey', derivedSource.journey, target)
        || checkPermission(appId, 'remove', 'guide', derivedSource.guide, target);
}

export function canPublishJourney ({ appId, source, target }) {
    return checkPermission(appId, 'publish', 'journey', source, target)
        || checkPermission(appId, 'publish', 'guide', source, target);
}

// Journey "active" status maps to guide "public" source for the OR-fallback check.
// When no explicit source is provided and the journey is active, derive appropriate
// source values for each entity type.
function deriveSourceFromStatus (source, journeyStatus) {
    if (!source && journeyStatus === ACTIVE) {
        return { journey: 'active', guide: 'public' };
    }

    return { journey: source, guide: source };
}
